import React, { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import { Sidebar } from '@/widgets'
import DelayedFallback from '@app/DelayedFallback'
import { Loader } from '@/components/Loader'

const MainLayout = () => {
	return (
		<div style={{ display: 'flex', minHeight: '100vh' }}>
			<Sidebar />
			<div style={{ flex: 1, minWidth: 0 }}>
				<Suspense
					fallback={
						<DelayedFallback delay={300}>
							<div style={{ padding: 24 }}>
								<Loader />
							</div>
						</DelayedFallback>
					}
				>
					<Outlet />
				</Suspense>
			</div>
		</div>
	)
}

export default MainLayout
